import React from 'react';
import { Circle, G, Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';
import { Colors } from '../../../themes/colors';

// Bulleted-list glyph for the message text-styles toolbar. Same glyph as the
// Gripp OS MessageComposer (Slack-style, not a Figma icon export).
export const BulletListIcon: React.FC<IconProps> = ({
  size = 16,
  color = Colors.role.textStrong,
  style,
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    overflow="visible"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <G
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <Path d="M9 6h12M9 12h12M9 18h12" />
    </G>
    <G fill={color}>
      <Circle cx="4" cy="6" r="1.4" />
      <Circle cx="4" cy="12" r="1.4" />
      <Circle cx="4" cy="18" r="1.4" />
    </G>
  </Svg>
);

BulletListIcon.displayName = 'BulletListIcon';
